import { createContext } from 'react';

/** Let a custom modal raise its nested portals without changing other popups. */
export const PortalLayerContext = createContext<string | undefined>(undefined);
